<template>
  <div class="card accompagnement-card h-100 shadow-sm">
    <div class="card-img-top-wrapper">
      <img
        src="@/assets/img/photo/TDAH.png"
        class="card-img-top"
        :alt="$t('enfantsEtAdolescentsResume.image.alt')"
      />
    </div>

    <div class="card-body d-flex flex-column">
      <h5 class="fw-bold" style="font-size: 1.3rem">
        {{ $t("enfantsEtAdolescentsResume.title") }}
      </h5>

      <p class="text-muted" style="font-size: 1rem; line-height: 1.4">
        {{ $t("enfantsEtAdolescentsResume.text.p1") }}
        <br />
        {{ $t("enfantsEtAdolescentsResume.text.p2") }}
      </p>

      <a
        href="/enfants-et-adolescents"
        class="btn btn-custom mt-2 w-100 mt-auto"
      >
        {{ $t("enfantsEtAdolescentsResume.button.more") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnfantsEtAdolescentsResume",
};
</script>

<style></style>
